import { Button, CircularProgress, Grid, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import { getClientes, getOpcionesEditProyectos, getOpcionesProyectos, getProyectos, opcinesMenu } from '../../services/apis';

import { ProyectoCard } from './ProyectoCard';
import { SubHeader } from '../../utils/componentes-utiles/SubHeader';
import { OpcionesMenuFunc } from '../../utils/componentes-utiles/OpcionesMenuFunc';
import { FormCrearProyecto } from './FormCrearProyecto';

//mapa de iconos


export const Proyectos = () => {
    // Global
    const navigate = useNavigate();

    // Estados auxiliares
    const [loaded, setLoaded] = useState(false);

    // Estados útiles
    const [clientes, setClientes] = useState([]);
    const [proyectos, setProyecto] = useState([]);
    const [opciones, setOpciones] = useState([]);
    const [proyectosCopia, setProyectosCopia] = useState([]);
    const [opcionesEdit, setOpcionesEdit] = useState([]);
    const [open, setOpen] = useState(false);
    const [opcionesDialog, setOpcionesDialog] = useState([]);
    const [openEdit, setOpenEdit] = useState(false);
    // Cargar opciones menú principal

    const cargarOpcionesAdm = async () => {
        try {
            const response = await getOpcionesProyectos();
            setOpciones(response.data.opcionesproyectos);
            setOpcionesDialog(response.data.opcionesdialogproyectos);
            setOpcionesEdit(response.data.opcionesEdit);

            setLoaded(true);
        } catch (error) {
            console.error("Error al añadir el cliente:", error);

        }
    };
    const cargarOpciones = async (oculto) => {
        try {
            const response = await getProyectos(oculto);
            setProyecto(response.data)
            setProyectosCopia(response.data);
            setLoaded(true);
        } catch (error) {
            console.error("Error al añadir el cliente:", error);

        }
    };

    const cargarClientes = async () => {
        try {
            const response = await getClientes();

            if (response.success) {
                setClientes(response.data);
            }

        } catch (error) {
            console.error("Error:", error);
        }
    }



    const handleEvent = (opcionId) => {
        switch (opcionId) {
            case 1:
                // setOpenEdit(true);
                setOpen(!open);

                // Lógica para la opción 1
                break;

            case 2:
                openEdit ? setOpenEdit(false) : setOpenEdit(true);
                cargarOpciones(openEdit ? 0 : 1);

                break;

            default:
                console.log("Lógica para una opción desconocida");
                // Lógica para una opción desconocida
                break;
        }
    }

    const buscarPy = (event) => {
        const searchTerm = event.target.value.toLowerCase();

        if (searchTerm === "") {
            // Si el campo de búsqueda está vacío, puedes restaurar la lista original
            // Por ejemplo:
            setProyecto(proyectosCopia);
            return;
        }

        const resultados = proyectosCopia.filter(proyecto => {
            return (
                proyecto.nombre.toLowerCase().includes(searchTerm) ||
                proyecto.descripcion.toLowerCase().includes(searchTerm)
            );
        });

        // Actualiza el estado con los resultados
        // Por ejemplo:
        setProyecto(resultados);
        console.log("Resultados de búsqueda:", resultados);
    }


    useEffect(() => {
        cargarOpciones(0);
        cargarOpcionesAdm();
        cargarClientes();
    }, []);

    return (
        <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            xs={12}
            className='menu-back fade-in2'
        >
            <SubHeader titulo={'Proyectos'} />


            {opciones && (
                <OpcionesMenuFunc opciones={opciones} handleEvent={handleEvent}></OpcionesMenuFunc>
            )}
            {
                !loaded && (
                    <CircularProgress />
                )
            }
            {/* <div className='menu-principal fade-in-2'> */}
            <Grid
                container
                direction="row"
                justifyContent="start"
                alignItems="start"
                xs={10.2}
                sx={{ mt: 2 }}
            >
                <TextField id="outlined-basic" label="Buscar..." name='search' variant="standard" sx={{ minWidth: '100%' }} onChange={(event) => buscarPy(event)} />

            </Grid>
            <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="center"
                xs={12}
                gap={2}
                sx={{ mt: 4 }}
            >
                {loaded && proyectos.length > 0 && (
                    proyectos.map(opcion => (
                        <ProyectoCard key={opcion.id} data={opcion} openEdit={openEdit} opciones={opcionesEdit} cargarOpciones={cargarOpciones} cargarOpcionesAdm={cargarOpcionesAdm} clientes={clientes}/>
                    ))
                )}
            </Grid>
            {/* </div> */}
            {open && (
                <FormCrearProyecto
                    open={open}
                    setOpen={setOpen}
                    cargarProyectos={cargarOpciones}
                    opciones={opcionesDialog}
                    setOpciones={setOpcionesDialog}
                />
            )}

        </Grid>



    )
}
